export const SET_ALL_VALUES = 'SET_ALL_VALUES';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const GET_PAYER_LIST_SUCCESS = 'GET_PAYER_LIST_SUCCESS';
export const GET_PAYER_LIST_ERROR = 'GET_PAYER_LIST_ERROR';
export const GET_PAYER_SUCCESS = 'GET_PAYER_SUCCESS';
export const GET_PAYER_ERROR = 'GET_PAYER_ERROR';
export const ADD_PAYER_SUCCESS = 'ADD_PAYER_SUCCESS';
export const ADD_PAYER_ERROR = 'ADD_PAYER_ERROR';
export const GET_PAYER_LOADING = 'GET_PAYER_LOADING';
export const ADD_SUBSCRIPTION_SUCCESS = 'ADD_SUBSCRIPTION_SUCCESS';
export const ADD_SUBSCRIPTION_ERROR = 'ADD_SUBSCRIPTION_ERROR';
export const EDIT_SUBSCRIPTION_SUCCESS = 'EDIT_SUBSCRIPTION_SUCCESS';
export const EDIT_SUBSCRIPTION_ERROR = 'EDIT_SUBSCRIPTION_ERROR';
export const REMOVE_SUBSCRIPTION_SUCCESS = 'REMOVE_SUBSCRIPTION_SUCCESS';
export const REMOVE_SUBSCRIPTION_ERROR = 'REMOVE_SUBSCRIPTION_ERROR';
export const GET_ADDRESS_SUCCESS = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_ERROR = 'GET_ADDRESS_ERROR';
export const EDIT_ADDRESS_SUCCESS = 'EDIT_ADDRESS_SUCCESS';
export const EDIT_ADDRESS_ERROR = 'EDIT_ADDRESS_ERROR';
export const REMOVE_ADDRESS_SUCCESS = 'REMOVE_ADDRESS_SUCCESS';
export const REMOVE_ADDRESS_ERROR = 'REMOVE_ADDRESS_ERROR';
export const ADD_DELIVERY_ADDRESS_SUCCESS = 'ADD_DELIVERY_ADDRESS_SUCCESS';
export const ADD_DELIVERY_ADDRESS_ERROR = 'ADD_DELIVERY_ADDRESS_ERROR';
export const EDIT_DELIVERY_ADDRESS_SUCCESS = 'EDIT_DELIVERY_ADDRESS_SUCCESS';
export const EDIT_DELIVERY_ADDRESS_ERROR = 'EDIT_DELIVERY_ADDRESS_ERROR';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_ERROR = 'GET_ORDER_ERROR';
export const GET_PLAN_LIST_SUCCESS = 'GET_PLAN_LIST_SUCCESS';
export const GET_PLAN_LIST_ERROR = 'GET_PLAN_LIST_ERROR';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_ERROR = 'UPDATE_ORDER_ERROR';
export const GET_ORDER_VALUE_SUCCESS = 'GET_ORDER_VALUE_SUCCESS';
export const GET_ORDER_VALUE_ERROR = 'GET_ORDER_VALUE_ERROR';
export const GET_ORDER_VALUE_START = 'GET_ORDER_VALUE_START';
export const SET_CREDIT_PAYMENT_SUCCESS = 'SET_CREDIT_PAYMENT_SUCCESS';
export const SET_CREDIT_PAYMENT_ERROR = 'SET_CREDIT_PAYMENT_ERROR';
export const SET_BOLETO_PAYMENT_SUCCESS = 'SET_BOLETO_PAYMENT_SUCCESS';
export const SET_BOLETO_PAYMENT_ERROR = 'SET_BOLETO_PAYMENT_ERROR';
export const GET_BANK_SLIP_PAYMENT_SUCCESS = 'GET_BANK_SLIP_PAYMENT_SUCCESS';
export const GET_BANK_SLIP_PAYMENT_ERROR = 'GET_BANK_SLIP_PAYMENT_ERROR';
export const SET_WAIT_SUBSCRIPTION = 'SET_WAIT_SUBSCRIPTION';
export const REMOVE_WAIT_SUBSCRIPTION = 'REMOVE_WAIT_SUBSCRIPTION';
export const SET_EDIT_SUBSCRIPTION = 'SET_EDIT_SUBSCRIPTION';
export const REMOVE_EDIT_SUBSCRIPTION = 'REMOVE_EDIT_SUBSCRIPTION';
export const APPLY_CUPOM_SUCCESS = 'APPLY_CUPOM_SUCCESS';
export const APPLY_CUPOM_ERROR = 'APPLY_CUPOM_ERROR';
export const REMOVE_CUPOM_SUCCESS = 'REMOVE_CUPOM_SUCCESS';
export const REMOVE_CUPOM_ERROR = 'REMOVE_CUPOM_ERROR';
export const SET_WAIT_CAMPAIGN = 'SET_WAIT_CAMPAIGN';
export const REMOVE_WAIT_CAMPAIGN = 'REMOVE_WAIT_CAMPAIGN';
export const APPLY_CAMPAIGN_SUCCESS = 'APPLY_CAMPAIGN_SUCCESS';
export const APPLY_CAMPAIGN_ERROR = 'APPLY_CAMPAIGN_ERROR';
export const NEW_REMOVE_SUBSCRIPTION_SUCCESS =
	'NEW_REMOVE_SUBSCRIPTION_SUCCESS';
export const SUCCESS_GIFT_CODE = 'SUCCESS_GIFT_CODE';
export const ERROR_GIFT_CODE = 'ERROR_GIFT_CODE';
export const SUCCESS_VERIFY_NUMBER = 'SUCCESS_VERIFY_NUMBER';
export const ERROR_VERIFY_NUMBER = 'ERROR_VERIFY_NUMBER';
export const APPLY_GTM_SUCCESS = 'APPLY_GTM_SUCCESS';
export const SUCCESS_TOKEN_CM_DRCONSULTA = 'SUCCESS_TOKEN_CM_DRCONSULTA';
export const ERROR_TOKEN_CM_DRCONSULTA = 'ERROR_TOKEN_CM_DRCONSULTA';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const SUCCESS_SIGNATURE_CHOSEN = 'SUCCESS_SIGNATURE_CHOSEN';
export const ERROR_SIGNATURE_CHOSEN = 'ERROR_SIGNATURE_CHOSEN';
export const SUCCESS_PLAN_LEVELLED = 'SUCCESS_PLAN_LEVELLED';
export const ERROR_PLAN_LEVELLED = 'ERROR_PLAN_LEVELLED';
export const GET_PHARMACEUTICAL_UNITS_LIST_SUCCESS = 'GET_PHARMACEUTICAL_UNITS_LIST_SUCCESS';
export const GET_PHARMACEUTICAL_UNITS_LIST_ERROR = 'GET_PHARMACEUTICAL_UNITS_LIST_ERROR';
